/* eslint-disable */
import { AlertAdapter, RegularButton } from 'pg-ui-library';
import { useParams, useNavigate } from 'react-router-dom';
import React from 'react';
import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useQuery } from '@tanstack/react-query';
import InvoiceService from 'src/services/invoice.service';
import { useApproveInvocie } from '../mutations/invoice.mutation';

import {
  ReopenTicketForm,
  ReopenTicketBody,
  ReopenTicketHeader,
  ReplyTextarea,
  ReopenFooter,
  ReopenQues,
  ReopenLabel,
} from './styles';

export const InvoiceSubmmisionModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  invoiceDetail?: any;
  // eslint-disable-next-line react/prop-types
}> = ({ isOpen, setIsOpen, invoiceDetail }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const invoiceIdShown = invoiceDetail?.invoiceShowId;
  const invoiceIdSend = invoiceDetail?.id;
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const companyId = '';

  const { isFetching, data, refetch } = useQuery(['invoice-details'], async () => {
    const result = await InvoiceService.getInvoiceDetails({ invoiceId: invoiceId });
    return result.data;
  });

  const approveInvocie = useApproveInvocie();

  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const formik = useFormik({
    initialValues: {
      comment: '',
    },
    onSubmit: async (values: any) => {
      console.log('values', values);
      console.log('invocieId', invoiceId);

      if (!invoiceId) {
        return;
      }
      const clientLocalDate = new Date().toLocaleDateString('en-CA');

      await approveInvocie.mutateAsync({
        invoiceId: invoiceId,
        invoice: {
          ...values,
          clientLocalDate,
        },
      });
      AlertAdapter('Invoice is Approved!', 'success');
      refetch();
      setIsOpen(!isOpen);
      navigate('/invoices');
    },
  });

  const handleBackClick = () => {
    navigate('/invoices');
  };

  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '700px',
          height: '420px',
          display: 'flex',
          flexDirection: 'column',
          padding: '0 40px 0 40px',
          background: '#F3F4F8',
          overflowY: 'hidden',
        },
      }}
    >
      <ReopenTicketForm onSubmit={formik.handleSubmit}>
        <ReopenTicketHeader>
          <h3 style={{ margin: 0, width: '80%' }}>
            {t('global.form.approveInvocie')} #{invoiceIdShown}
          </h3>

          <CloseIcon
            src={closeSvg}
            onClick={handleModal}
            style={{
              position: 'absolute',
              right: '40px',
              top: '20px',
              cursor: 'pointer',
            }}
          />
        </ReopenTicketHeader>
        <ReopenTicketBody>
          <ReopenQues>
            <p>Are you sure you want to Approve this Invoice?</p>
          </ReopenQues>
          <ReopenLabel>Comment</ReopenLabel>
          <ReplyTextarea
            placeholder="Enter here..."
            value={formik.values.comment}
            onChange={event => formik.setFieldValue('comment', event.target.value)}
          />
          <ReopenFooter>
            <RegularButton
              disabled={formik.isSubmitting || !formik.isValid}
              type="submit"
              style={{ color: '#4948AC', backgroundColor: '#fff' }}
              onClick={() => handleModal()}
            >
              {t('global.form.cancel')}
            </RegularButton>
            <RegularButton disabled={formik.isSubmitting || !formik.isValid} type="submit">
              Confirm
            </RegularButton>
          </ReopenFooter>
        </ReopenTicketBody>
      </ReopenTicketForm>
    </ReactModal>
  );
};
